import { render, staticRenderFns } from "./UcRentalServiceCostAllocators.yaml?vue&type=template&id=46570a4e&component"
import script from "./UcRentalServiceCostAllocators.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalServiceCostAllocators.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports